<div class="thumbnail-tab">
  <input
    #clipPreviewFileInput
    type="file"
    class="thumbnail-tab__sr-only-file"
    accept="image/png,image/jpeg,image/jpg,image/webp,image/gif"
    (change)="onClipPreviewFileSelected($event)"
    aria-label="Upload thumbnail preview image"
  />
  <div class="thumbnail-tab__section">
    <label class="thumbnail-tab__label">Destination</label>
    <evrideo-clipping-studio-destination-picker
      [selectedDestinationId]="selectedDestinationId"
      (selectedDestinationIdChange)="onDestinationDropdownChange($event)"
    ></evrideo-clipping-studio-destination-picker>
    <p *ngIf="!hasSpecificDestination" class="thumbnail-tab__info" role="status">
      When All destinations is selected, this thumbnail is used in the publications list in this app. It is not applied as a platform cover — select a destination above to set one for that destination.
    </p>
  </div>

  <div class="thumbnail-tab__section thumbnail-tab__section--clip-preview">
    <label class="thumbnail-tab__label">
      Clip Preview
    </label>

    <div class="thumbnail-tab__preview-shell">
      <div
        class="thumbnail-tab__preview"
        [ngClass]="previewAspectRatioClass(currentAspectRatio)"
        [class.thumbnail-tab__preview--capturing]="isCapturingSnapshot"
      >
        <div
          *ngIf="isCapturingSnapshot"
          class="thumbnail-tab__capturing-overlay"
          aria-live="polite"
        >
          <span class="thumbnail-tab__capturing-spinner" aria-hidden="true"></span>
          <span class="thumbnail-tab__capturing-label">Capturing snapshot…</span>
        </div>
        <div class="thumbnail-tab__preview-hover">
          <button
            type="button"
            class="thumbnail-tab__preview-hover-icon"
            [disabled]="isCapturingSnapshot"
            (click)="openImagePreview()"
            aria-label="Open thumbnail image preview"
          >
            <svg
              class="thumbnail-tab__preview-hover-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          </button>
        </div>
        <img
          *ngIf="clipPreviewDisplayUrl"
          [src]="clipPreviewDisplayUrl"
          alt="Thumbnail Preview"
          class="thumbnail-tab__preview-img"
        />
        <div *ngIf="!clipPreviewDisplayUrl" class="thumbnail-tab__preview-placeholder">
          No thumbnail selected
        </div>
        <span class="thumbnail-tab__badge">{{ currentAspectRatio }}</span>
      </div>
    </div>

    <button
      type="button"
      class="thumbnail-tab__btn thumbnail-tab__btn--primary"
      [disabled]="isTikTokSourceSnapshotDisabled || isCapturingSnapshot"
      (click)="onTakeSnapshot()"
    >
      <!-- Lucide "camera" — same as <Camera /> in figma/src/app/components/RightSidebar.tsx -->
      <svg
        class="thumbnail-tab__btn-icon thumbnail-tab__btn-icon--lucide"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path
          d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
        />
        <circle cx="12" cy="13" r="3" />
      </svg>
      <span>{{ isCapturingSnapshot ? "Capturing snapshot…" : "Take Snapshot" }}</span>
    </button>

    <button
      type="button"
      class="thumbnail-tab__btn thumbnail-tab__btn--secondary"
      [disabled]="isSelectedDestinationTikTok || isCapturingSnapshot"
      (click)="openEditor()"
    >
      <!-- Lucide "edit-2" — same as <Edit2 /> in figma/src/app/components/RightSidebar.tsx -->
      <svg
        class="thumbnail-tab__btn-icon thumbnail-tab__btn-icon--lucide"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
        <path d="m15 5 4 4" />
      </svg>
      <span>Edit Thumbnail</span>
    </button>
    <p *ngIf="isSelectedDestinationTikTok" class="thumbnail-tab__info">
      {{
        isTikTokSourceSnapshotDisabled
          ? "TikTok does not support custom thumbnail images. Switch to Edit mode to choose a frame from the video."
          : "TikTok does not support custom thumbnail images. Choose a frame from the video instead."
      }}
    </p>
    <p *ngIf="isSelectedDestinationInstagram" class="thumbnail-tab__info">
      Instagram Stories do not support custom covers. Covers apply to Reels only.
    </p>
  </div>
</div>

<div
  *ngIf="showImagePreview"
  class="thumbnail-image-preview"
  (click)="closeImagePreview()"
>
  <div class="thumbnail-image-preview__backdrop"></div>
  <div
    class="thumbnail-image-preview__dialog"
    role="dialog"
    aria-modal="true"
    aria-label="Thumbnail image preview"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="thumbnail-image-preview__close"
      aria-label="Close image preview"
      (click)="closeImagePreview()"
    >
      &times;
    </button>
    <div
      class="thumbnail-image-preview__canvas"
      [style.aspect-ratio]="currentAspectRatio.replace(':', ' / ')"
    >
      <img
        *ngIf="clipPreviewDisplayUrl"
        [src]="clipPreviewDisplayUrl"
        alt="Thumbnail image preview"
        class="thumbnail-image-preview__img"
      />
    </div>
  </div>
</div>

<div *ngIf="showEditor" class="thumbnail-editor">
  <div class="thumbnail-editor__backdrop" [class.thumbnail-editor__backdrop--closing]="isEditorClosing" (click)="closeEditor()"></div>
  <div
    class="thumbnail-editor__dialog"
    [ngClass]="editorDialogClass(editorActiveRatio)"
    [class.thumbnail-editor__dialog--closing]="isEditorClosing"
    role="dialog"
    aria-modal="true"
  >
    <div class="thumbnail-editor__header">
      <h3 class="thumbnail-editor__title">Edit Thumbnail</h3>
      <button
        type="button"
        class="thumbnail-editor__close"
        aria-label="Close"
        (click)="closeEditor()"
      >
        &times;
      </button>
    </div>

    <div class="thumbnail-editor__body">
      <div class="thumbnail-editor__column thumbnail-editor__column--source">
        <h4 class="thumbnail-editor__subtitle">Source</h4>
        <button
          type="button"
          class="thumbnail-editor__ghost-btn"
          (click)="openClipPreviewUpload()"
        >
          <i class="fa fa-upload thumbnail-editor__ghost-btn-icon" aria-hidden="true"></i>
          <span>Upload Image</span>
        </button>
      </div>

      <div class="thumbnail-editor__column thumbnail-editor__column--preview">
        <div class="thumbnail-editor__subtitle-row">
          <h4 class="thumbnail-editor__subtitle">Preview</h4>
          <span class="thumbnail-editor__ratio">{{ editorActiveRatio }}</span>
        </div>
        <div class="thumbnail-editor__canvas-shell">
          <div
            #editorCanvasRef
            class="thumbnail-editor__canvas"
            [ngClass]="editorAspectRatioClass(editorActiveRatio)"
            [class.thumbnail-editor__canvas--dragging]="isEditorDragging"
            (mousedown)="startEditorImageDrag($event)"
          >
            <img
              *ngIf="editorImageUrl"
              #editorImageRef
              [src]="editorImageUrl"
              alt="Thumbnail editor preview"
              class="thumbnail-editor__canvas-img"
              [class.thumbnail-editor__canvas-img--fit-width]="editorImageFitMode === 'width'"
              [class.thumbnail-editor__canvas-img--fit-height]="editorImageFitMode === 'height'"
              [style.transform]="editorImageTransform"
              (load)="onEditorImageLoaded($event)"
            />
            <div
              *ngIf="!editorImageUrl"
              class="thumbnail-editor__canvas-placeholder"
            >
              No thumbnail selected
            </div>
            <div class="thumbnail-editor__crop-frame">
              <span class="thumbnail-editor__crop-handle thumbnail-editor__crop-handle--tl"></span>
              <span class="thumbnail-editor__crop-handle thumbnail-editor__crop-handle--tr"></span>
              <span class="thumbnail-editor__crop-handle thumbnail-editor__crop-handle--bl"></span>
              <span class="thumbnail-editor__crop-handle thumbnail-editor__crop-handle--br"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="thumbnail-editor__column thumbnail-editor__column--controls">
        <h4 class="thumbnail-editor__subtitle">EDIT THUMBNAIL</h4>

        <div class="thumbnail-editor__zoom-block">
          <div class="thumbnail-editor__zoom-header">
            <label class="thumbnail-editor__field-label thumbnail-editor__field-label--zoom">ZOOM</label>
            <span class="thumbnail-editor__zoom-value">{{ editorZoom }}%</span>
          </div>
          <input
            type="range"
            class="thumbnail-editor__zoom-slider"
            min="50"
            max="200"
            [ngModel]="editorZoom"
            (ngModelChange)="onEditorZoomChange($event)"
            [style.--zoom-progress]="((editorZoom - 50) * 100) / 150 + '%'"
          />
        </div>

        <button
          type="button"
          class="thumbnail-editor__link-btn"
          (click)="resetEditorCrop()"
        >
          Reset Crop
        </button>

      </div>
    </div>

    <div class="thumbnail-editor__footer">
      <button
        type="button"
        class="thumbnail-editor__btn thumbnail-editor__btn--cancel"
        (click)="onEditorCancel()"
      >
        Cancel
      </button>
      <div class="thumbnail-editor__footer-right">
        <button
          type="button"
          class="thumbnail-editor__btn thumbnail-editor__btn--icon"
          aria-label="Download thumbnail"
          (click)="onEditorDownload()"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button
          type="button"
          class="thumbnail-editor__btn thumbnail-editor__btn--apply"
          (click)="onEditorApply()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
